//正则验证：直接引入组件，传需要验证的参数即可，不需要再写test

/**
 * 邮箱
 * @param {*} s
 */
 function isEmail (s) {
    return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
 function isMobile (s) {
    return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
 function isPhone (s) {
    return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * url地址
 * @param s
 * @returns {boolean}
 */
function isUrl (url) {
    return /^https?:\/\/.+/.test(url)
}

/**
 * URL地址
 * @param {*} s
 */
 function isURL (s) {
    return /^http[s]?:\/\/.*/.test(s)
}

export default {isEmail,isMobile,isPhone,isURL}
